import React from 'react';
import { Input } from 'antd';

import { CHART_DESCRIPTION_MAX, CHART_NAME_MAX } from '../reports/NameChartModal';
import BuilderStep from './BuilderStep';
import { Field } from './controls';
import { messageProps } from './FieldMessage';

/**
 * The last step, Name: what the chart is called on Reports and on its page,
 * and a sentence on what it answers. A new chart is offered a name made from
 * its question ("Total of Amount by month") until its author types one.
 */
export default function NameStep({ number, name, description, onName, onDescription, messagesFor, step }) {
	const nameMessages = messagesFor('name');
	const descriptionMessages = messagesFor('description');
	return (
		<BuilderStep step='name' number={number} title='Name' {...step}>
			<Field id='chart-builder-name' label='Name' messages={nameMessages}>
				<Input
					id='chart-builder-name'
					value={name}
					maxLength={CHART_NAME_MAX}
					onChange={(event) => onName(event.target.value)}
					{...messageProps(nameMessages, 'chart-builder-name-messages')}
				/>
			</Field>
			<Field id='chart-builder-description' label='Description' messages={descriptionMessages}>
				<Input.TextArea
					id='chart-builder-description'
					value={description}
					maxLength={CHART_DESCRIPTION_MAX}
					autoSize={{ minRows: 2, maxRows: 5 }}
					placeholder='What this chart answers, in a sentence'
					onChange={(event) => onDescription(event.target.value)}
					{...messageProps(descriptionMessages, 'chart-builder-description-messages')}
				/>
			</Field>
		</BuilderStep>
	);
}
